import { render, staticRenderFns } from "./Comunication.vue?vue&type=template&id=f023fb4a&scoped=true&"
import script from "./Comunication.vue?vue&type=script&lang=js&"
export * from "./Comunication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f023fb4a",
  null
  
)

export default component.exports